import React from 'react';
import s from './Button.module.css';

// The app's button.
//
// A CSS module, so the rules are bundled once.

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  onClick,
  type = 'button',
  style,
  icon,
  // Appended rather than replacing the variant classes: a caller adds layout
  // (full width, a margin), not a different look.
  className,
  ...rest
}) {
  const classes = [s.base, s[size], s[variant], className].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      style={style}
      {...rest}
    >
      {loading ? <span className={s.spinner} /> : icon || null}
      {children}
    </button>
  );
}
